"use strict";

import angular from "angular";

/**
 * @component NuSteps
 * O <nu-steps> é um componente para steps
 */

import template from "./steps.component.html";
import "./steps.component.scss";

const name = "nuSteps";
const def = {
    bindings: {
        steps: "=",
        currentStep: "="
    },
    controllerAs: "stepsCtrl",
    template
};
angular.module("nucont.shared").component(name, def);
export default { name, ...def };
